import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { getIcon } from 'utils/icons';
import Spinner from 'components/spinner/spinner';
import s from 'components/button/button.sss';

// Example usage:
// <Button icon="save" />
// <Button dark>Text</Button>
// <Button outline dark icon={CustomIcon}>Button</Button>
// <Button danger onClick={...}>Delete</Button>
// <Button outline href="https://example.com" target="_blank">Link</Button>
// <Button expandOnHover icon="save">Save</Button>
// <Button primary icon="chevron-down" iconAlt="chevron-down">
// 	Link
// 	<div popover="auto" id="example">
// 		<Button>Dropdown option 1</Button>
// 	</div>
// </Button>

export default class Button extends Component {
	constructor(props) {
		super(props);
		this.state = {
			popoverId: this.getPopoverId(props) || crypto.randomUUID(),
		};
	}

	componentWillReceiveProps(props) {
		const popoverId = this.getPopoverId(props);
		if (popoverId && popoverId !== this.state.popoverId) {
			this.setState({ popoverId });
		}
	}

	componentDidMount() {
		this.forceStyle(this.base);
	}

	componentDidUpdate() {
		this.forceStyle(this.base);
	}

	forceStyle(el) {
		if (!el || !el.dataset.style) return;
		el.setAttribute('style', el.dataset.style);
	}

	getPopoverId(props = this.props) {
		const popover = props.children.find(e => e?.attributes?.popover);
		// crypto.randomUUID() is not available in insecure contexts - is it an issue for some testing envs ?
		// Should we just assume popovers will always provide their own id ?
		return !popover ? null : popover.attributes.id;
	}

	renderButton(props = this.props) {
		const hasPlainText = props.children.some(e => typeof e === 'string' && e.trim());
		let Tag = 'button';
		const mirroredProps = [
			'id',
			'type',
			'name',
			'value',
			'popovertarget',
			'disabled',
			'formnovalidate',
			'tabIndex',
			'autofocus',
			'title',
			'style',
		].concat(
			// data-* and onEvent props
			Object.keys(props).filter(
				p => p.startsWith('data-') || /^on\p{Uppercase}/u.test(p)
			)
		);
		if (props.href) {
			Tag = 'a';
			mirroredProps.push('href', 'target', 'rel', 'download');
		}
		if (props.tag) Tag = props.tag;

		const showLoading = props.loading && (!props.iconAlt || props.iconAlt === 'none');
		const showLoadingAlt = props.loading && !showLoading;

		return (
			<Tag
				class={joinClasses(
					s.button,
					props.dark && s.dark,
					props.text && s.text,
					props.outline && s.outline,
					props.primary && s.primary,
					props.danger && s.danger,
					props.disabled && s.disabled,
					props.small && s.small,
					props.expandOnHover && s.expandOnHover,
					s[`icon-size-${props.iconSize}`],
					hasPlainText && s.hasPlainText,
					props.class,
				)}
				{...Object.fromEntries(mirroredProps.map(p => [p, props[p]]))}
			>
				{showLoading ? <Spinner /> : getIcon(props.icon)}
				{props.expandOnHover ? <span class={s.expandText}><span>{props.children}</span></span> : props.children}
				{props.counter != undefined && <div class={s.counter} data-type="counter">{props.counter}</div>}
				{showLoadingAlt ? <Spinner /> : getIcon(props.iconAlt)}
			</Tag>
		);
	}

	render(props) {
		const popover = props.children.find(e => e?.attributes?.popover);
		if (!popover) {
			return this.renderButton();
		}
		const wrapperProps = Object.fromEntries(
			Object.entries(props).map(
				([prop, val]) => [prop.match(/^wrapper-(data-.+)$/)?.[1], val]
			).filter(e => e[0])
		);
		const popoverId = this.state.popoverId;
		if (!popover.attributes.id) popover.attributes.id = popoverId;
		return (
			<div class={joinClasses(s.dropdownWrapper, props.class)} {...wrapperProps} data-style={`anchor-name: --${popoverId}; --anchor-name: --${popoverId}`}>
				{this.renderButton({ ...props, class: null, children: props.children.filter(e => e !== popover) })}
				{props.popovertarget !== popoverId && this.renderButton({
					...props,
					class: s.dropdown,
					children: [],
					type: 'button',
					id: null,
					popovertarget: popoverId,
					icon: 'chevron-down',
					iconAlt: null,
					counter: null,
					onClick: null,
					href: null,
				})}
				{popover}
			</div>
		);
	}
}